"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jwt_decode_1 = __importDefault(require("jwt-decode"));
class AuthenticatedUser {
    static factory(jwtToken = "") {
        try {
            AuthenticatedUser.token = jwtToken;
            return new AuthenticatedUser((0, jwt_decode_1.default)(jwtToken));
        }
        catch (_) {
            return null;
        }
    }
    constructor({ id, email, permissions, exp, }) {
        this.id = id;
        this.email = email;
        this.permissions = permissions;
        this.exp = exp;
    }
    static getToken() {
        return AuthenticatedUser.token;
    }
    hasPermission(permission) {
        if (!Array.isArray(this.permissions)) {
            return false;
        }
        return this.permissions.includes(permission);
    }
}
exports.default = AuthenticatedUser;
